/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class StatementsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      groups: this.store.query('group', { year: moment().year() }),
      learners: this.store.query('person', { type: PersonType.LEARNER }),
      caregivers: this.store.query('person', { type: PersonType.CAREGIVER }),
    });
  }

  resetController() {
    this.controller.reset();
  }
}
